var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const makeRequest_1 = __importDefault(require("@hendersonengineers/utils/makeRequest"));
const constants_1 = require("./constants");
class SignalRMessage {
    constructor(hubName, messageName, data) {
        this.hubName = hubName;
        this.messageName = messageName;
        this.data = data;
    }
    toAll() {
        return (0, makeRequest_1.default)(this.getRequestOptions('all'));
    }
    toOthers() {
        return (0, makeRequest_1.default)(this.getRequestOptions('others'));
    }
    toCaller() {
        return (0, makeRequest_1.default)(this.getRequestOptions('caller'));
    }
    toUsers(...usernames) {
        return (0, makeRequest_1.default)(this.getRequestOptions(usernames));
    }
    getRequestOptions(to) {
        const input = {
            hubName: this.hubName,
            messageName: this.messageName,
            data: this.data
        };
        let endpoint;
        if (typeof to === 'string') {
            endpoint = 'Emit';
            input.to = to;
        }
        else {
            endpoint = 'EmitToUsers';
            input.toUsernames = to;
        }
        return {
            action: 'Create',
            origin: constants_1.SIGNALR_URL,
            route: `API/${endpoint}`,
            data: input
        };
    }
}
exports.default = SignalRMessage;
//# sourceMappingURL=SignalRMessage.js.map